/* Initialize re-usable variable declarations */
var touchDevice, addOnsWindowWidth, scrollThreshold, toggleHeaderResizeTimeout, menuMobileImprovedClass, navLinkIconStatusClass, slideDownLayout, mouseX, mouseY, slideDownVisible, clickTimeout, specificNavItemSelector, specificNavItemNotSelector, toggleHeaderData, headerContentHeight, searchPlaceholderText;

/* Initialize legacy re-usable variable declarations */
var menuMobileImprovedClassLegacy, mobileDropdownLegacy;

/* Initialize element declarations */
var header, swipedTile, allMenuItems, menuBar, mobileDropdown, activeMenuItem, slideDown, mobileMenuIcons, headerOuter, titleBar, toggleButtonElement, allFeaturedImageSections, searchContainers, slideDownMenuBarContainer, allSubMenuItems, allSubSubMenuItems, sectionOuter, menuMobileInnerContainer, mobileMenuFooter;
var reusableVariablesInitialized = false;

window.Branch = window.Branch || {};
window.Branch.nav = window.Branch.nav || {};

function initToggleHeaderReusableVariableDeclarations(){
    /* Assign values to element declarations */
    if(reusableVariablesInitialized == false){
        header = document.querySelector('.toggle-header');
        if(header){
            allMenuItems = header.querySelectorAll('.toggle-header-menu-bar-container__item');
            menuBar = header.querySelector('.toggle-header__menu-bar');
            slideDown = document.querySelector('.toggle-header__slide-down-container');
            headerOuter = document.querySelector('.toggle-header__outer');
            titleBar = header.querySelector('.toggle-header__title-bar');
            toggleButtonElement = headerOuter.querySelector('.toggle-header-title-bar-container__toggle-dtc-element')
            allFeaturedImageSections = document.querySelectorAll('.custom-feature-image-section .custom-feature-image')
            sectionOuter = document.querySelector('#shopify-section-header');
            mobileMenuIcons = header.querySelectorAll('.menu-mobile-improved__nav-link');
            mobileDropdown = document.querySelector('.menu-mobile-improved')
            mobileDropdownLegacy = document.querySelector('.menu-mobile-improved-legacy')
            menuMobileInnerContainer = mobileDropdown.querySelector('.menu-mobile-improved__inner-container')
            mobileMenuFooter = mobileDropdown.querySelector('.menu-mobile-improved__footer')

            /* Assign values to re-usable variable declarations */
            touchDevice = window.Branch.functions.isTouchDevice();
            toggleHeaderWindowWidth = window.innerWidth;
            slideDownLayout = headerOuter.getAttribute('data-scroll-down-layout');
            mouseX = 0;
            mouseY = 0;
            isDragging = false;
            slideDownVisible = false;
            searchPlaceholderText = "Search for products, collections, ergonomic support";
            reusableVariablesInitialized = true;
            menuMobileImprovedClass = 'menu-mobile-improved--STATUS';
            menuMobileImprovedClassLegacy = 'menu-mobile-improved-legacy--STATUS';
            navLinkIconStatusClass = 'menu-mobile-improved__nav-icon--STATUS';
            scrollThreshold = 200;
            specificNavItemSelector = '.menu-mobile-improved__nav-item.menu-mobile-improved__nav-item--has-dropdown[data-item-index="PLACEHOLDER"]';
            specificNavItemNotSelector = `.menu-mobile-improved__nav-item.menu-mobile-improved__nav-item--has-dropdown:not([data-item-index="PLACEHOLDER"])`;
            toggleHeaderData = document.querySelector('#toggle-header-data') ? JSON.parse(document.querySelector('#toggle-header-data').innerText) : {};

        }
    }
}

/* Close all active dropdowns */
const closeAllActiveMenuItems = function(){
    allMenuItems.forEach((menuItem) => {
        if(menuItem.getAttribute('data-active') == 'true' && menuItem.querySelector('.toggle-header-menu-dropdown')){
            menuItem.querySelector('.toggle-header-menu-dropdown .toggle-header-menu-dropdown__outer-container').style.transform = `translateY(-${menuItem.querySelector('.toggle-header-menu-dropdown').offsetHeight}px)`
            menuItem.setAttribute('data-active', false);
        }
    });
    headerOuter.setAttribute('data-dropdown-open', false);
    activeMenuItem = undefined;
}

/* Close all active dropdowns if click outside occurs */
const handleClickOutside = function(e){
    if (activeMenuItem && activeMenuItem.closest('.toggle-header__menu-bar') && !activeMenuItem.closest('.toggle-header__menu-bar').contains(e.target)) {
        let clickOnSearch = false;
        searchContainers.forEach((searchContainer) => {
            if(searchContainer.contains(e.target)){
                clickOnSearch = true;
            }
        })
        if(clickOnSearch == false){
            closeAllActiveMenuItems();
            document.removeEventListener('click', handleClickOutside);
        }
      }
}

/* Update styling and attributes of clicked-on/hovered-over menu item, in order to show the dropdown menu */
const handleDropdownOpen = function(currentItemDropdown, newActiveStatus, currentItem){
    if(currentItemDropdown){

        let currentItemDropdownOuter = currentItemDropdown.querySelector('.toggle-header-menu-dropdown__outer-container');
        if(newActiveStatus){
            currentItemDropdownOuter.style.transform = `translateY(0)`;
            currentItem.setAttribute('data-active', true)
            activeMenuItem = currentItem;
            headerOuter.setAttribute('data-dropdown-open', true);
        }

        if(currentItemDropdown.getAttribute('data-carousels-initialized') == 'false'){
            initProductCarousels(currentItemDropdown);
        }

        /* Add 'click outside' event listener to document object */
        if(touchDevice == true && newActiveStatus == true){
            document.addEventListener('click', handleClickOutside);
        }
    }
}

/* Determine of click-on/hover-over menu items should be opened or closed, and update styling/attributes accordingly */
const toggleDropDownVisibility = function(e, targetItem){
    let currentItem = e ? window.Branch.functions.getElementWithClass(e, 'toggle-header-menu-bar-container__item') : targetItem;
    if(currentItem){
        let newActiveStatus = currentItem.getAttribute('data-active') == 'false' ? true : false;
        let currentItemDropdown = currentItem.querySelector('.toggle-header-menu-dropdown');

        headerOuter.setAttribute('data-transitioning', true);
        document.removeEventListener('click', handleClickOutside);

        if(headerOuter.getAttribute('data-dropdown-open') == 'false'){
            currentItem.setAttribute('data-active', newActiveStatus);
            currentItem.querySelector('.toggle-header-menu-bar-container__item-link').setAttribute('aria-expanded', newActiveStatus)    
            handleDropdownOpen(currentItemDropdown, newActiveStatus, currentItem);
            setTimeout(function(){
                headerOuter.setAttribute('data-transitioning', false);
            }, 250);
        } else {
            closeAllActiveMenuItems();
            setTimeout(function(){
                currentItem.setAttribute('data-active', newActiveStatus);
                currentItem.querySelector('.toggle-header-menu-bar-container__item-link').setAttribute('aria-expanded', newActiveStatus)        
                handleDropdownOpen(currentItemDropdown, newActiveStatus, currentItem);
                setTimeout(function(){
                    headerOuter.setAttribute('data-transitioning', false);
                }, 240);
            }, 10)
        }
        if(headerOuter.getAttribute('data-nav-interacted-with') == 'false'){
            headerOuter.setAttribute('data-nav-interacted-with', true);
            preLoadCarouselImages();
        }
    }
}



/* Set transform value for all non-active dropdowns */
const updateDropDownTransformValue = function(){
    allMenuItems.forEach((menuItem) => {
        if(menuItem.getAttribute('data-active') == 'false' && menuItem.querySelector('.toggle-header-menu-dropdown')){
            menuItem.querySelector('.toggle-header-menu-dropdown .toggle-header-menu-dropdown__outer-container').style.transform = `translateY(-${menuItem.querySelector('.toggle-header-menu-dropdown').offsetHeight}px)`
        } 
    })
}

/* Hide excess nav items if the containing space is too small */
const hideExcessItems = function() {
    let ulElements = headerOuter.querySelectorAll('.toggle-header__slide-down-nav-container>ul, .toggle-header-menu-bar-container>ul');
    ulElements.forEach((ul) => {
        const liElements = Array.from(ul.querySelectorAll('li.toggle-header-menu-bar-container__item'));
        const ulWidth = ul.clientWidth;
    
        let totalWidth = 0;
        
        liElements.forEach(li => {
          totalWidth += li.offsetWidth;
          if (totalWidth <= ulWidth) {
            li.setAttribute('data-hidden', false);
          } else {
            li.setAttribute('data-hidden', true);
          }
        });
    })  
  }

const createStandInNavItems = function(containerSelector, type){
    ['b2b', 'dtc'].forEach((type) => {
        let innerUl = header.querySelector(`.toggle-header-menu-bar-container[data-type="${type}"] > ul`) ? header.querySelector(`.toggle-header-menu-bar-container[data-type="${type}"] > ul`) : slideDown.querySelector(`.toggle-header__slide-down-nav-container[data-type="${type}"]>ul`);
        let clonedInnerUl = innerUl.cloneNode(false);
        
        Array.from(innerUl.children).forEach(child => {
            const button = child.querySelector('button').cloneNode(true); 
            button.setAttribute('aria-hidden', true);
            const listItem = document.createElement('li');
            listItem.appendChild(button);
            clonedInnerUl.appendChild(listItem);
        });

        headerOuter.querySelector(`${containerSelector.replace('DATATYPE', type)}`).appendChild(clonedInnerUl);        
    });

    if(slideDownLayout == 'nav_items_bar_and_header_bar' && type == 'slide-down'){
        let titleBarToClone = header.querySelector('.toggle-header__title-bar');
        let clonedTitleBar = titleBarToClone.cloneNode(true);
        headerOuter.querySelector(`.toggle-header__slide-down-header`).appendChild(clonedTitleBar);
    }
}

 const triggerMouseEnterOnHoveredItem = function() {
    const hoveredElement = document.elementFromPoint(mouseX, mouseY);
    if (!hoveredElement) return; 
    const targetItem = hoveredElement.closest('.toggle-header-menu-bar-container__item');

    if (targetItem && targetItem.getAttribute('data-active') == 'false') {
        toggleDropDownVisibility(false, targetItem)
    }
  }

const updateBundleStepsHeaderHeights = function(){
    window.Branch.functions.updateHeightInCategory('.toggle-header .toggle-header-menu-dropdown__bundle-steps-outer-container', '.toggle-header .toggle-header-menu-dropdown__bundle-steps-outer-container .toggle-header-menu-dropdown__bundle-step-title')
}

const updateSubMenuItemHeights = function(){
    window.Branch.functions.updateHeightInCategory('.toggle-header-menu-bar-container__submenu[data-sub-menu-items-layout="sub-menu-items-and-sub-sub-menu-items"]', '.toggle-header-menu-bar-container__submenu-item > .toggle-header-menu-bar-container__submenu-item-link')
}

const updateSlideDownStyling = function(){
    slideDown.style.height = slideDownLayout == 'nav_items_bar_and_header_bar' ? `${titleBar.offsetHeight + menuBar.offsetHeight}px` : `${menuBar.offsetHeight}px`;
    

    handleToggleHeaderScroll();

    if(slideDown.getAttribute('data-initialized') != 'true'){
        createStandInNavItems(`.toggle-header__slide-down-inner-container[data-type="DATATYPE"]`, 'slide-down');

        if(slideDownLayout != 'nav_items_bar_and_header_bar'){
            let dtcLogoInnerClone = header.querySelector('.toggle-header-title-bar-container__logo-inner a[data-type="dtc"]').cloneNode(true);
            let cartIconClone = header.querySelector('.toggle-header-title-bar-container__utils-inner .cart-wrap').cloneNode(true);

            slideDown.querySelector('.toggle-header__slide-down-logo-container-inner').appendChild(dtcLogoInnerClone);
            slideDown.querySelector('.toggle-header__slide-down-cart-icon-container-inner').appendChild(cartIconClone)
        }

        setTimeout(function(){
            slideDown.setAttribute('data-initialized', true);
        }, 250)
    }
}

const handleMobileNavItemClick = function(e, type, itemIndex){
    e.preventDefault();
    let clickStraightThrough = e && e.target && e.target.closest('.menu-mobile-improved__nav-item') ? e.target.closest('.menu-mobile-improved__nav-item').getAttribute('data-skip-dropdown') == 'true' : false; 
    if(clickStraightThrough){
        const currentUrl = window.location.origin;
        window.location.href = `${currentUrl}${e.target.closest('.menu-mobile-improved__nav-item').querySelector('.menu-mobile-improved__nav-item-link').getAttribute('href')}`;
    } else {
        if(headerOuter.getAttribute('data-nav-interacted-with') == 'false'){
            headerOuter.setAttribute('data-nav-interacted-with', true);
            preLoadCarouselImages();
        }

        let targetItem = type == 'click_outside' ?  document.querySelectorAll(`${specificNavItemSelector.replace('PLACEHOLDER', '1')}`)[0] : document.querySelectorAll(`${specificNavItemSelector.replace('PLACEHOLDER', `${itemIndex}`)}`)[0];

        if(type !== 'click_outside' && targetItem.getAttribute('data-carousels-initialized') == 'false'){
            initProductCarousels(targetItem);
        }

        let value = type == 'click_outside' ? 'open' : targetItem.getAttribute('data-status');
        let index = targetItem.getAttribute('data-item-index');
        let items = document.querySelectorAll(`${specificNavItemSelector.replace('PLACEHOLDER', `${index}`)}`);
        let allOtherItems = document.querySelectorAll(`${specificNavItemNotSelector.replace('PLACEHOLDER', `${index}`)}`);
        let newValue = value == 'closed' ? 'open' : 'closed';

        let utilityBarHeight = document.querySelector('.toggle-header__utility-bar') && window.scrollY <= scrollThreshold ? document.querySelector('.toggle-header__utility-bar').offsetHeight : -1;


        let mobileContentHeight = `${window.innerHeight - utilityBarHeight - 56}px`;

        // console.log('mobileContentHeight', mobileContentHeight)
    
        items.forEach((item) => {
            if(allOtherItems.length > 0) {
                allOtherItems.forEach((singleItem) => {
                    singleItem.classList.remove(`${'menu-mobile-improved__nav-item--PLACEHOLDER'.replace('PLACEHOLDER', 'open')}`);
                    singleItem.classList.add(`${'menu-mobile-improved__nav-item--PLACEHOLDER'.replace('PLACEHOLDER', 'closed')}`);
                    singleItem.setAttribute('data-status', 'closed');
                    
                })
            }

            item.style.pointerEvents = "none";
            item.classList.remove(`${'menu-mobile-improved__nav-item--PLACEHOLDER'.replace('PLACEHOLDER', 'open')}`);
            item.classList.remove(`${'menu-mobile-improved__nav-item--PLACEHOLDER'.replace('PLACEHOLDER', 'closed')}`);
            item.setAttribute('data-status', newValue);
            item.closest('.menu-mobile-improved__nav').style.height = `${newValue == "open" ? mobileContentHeight : 'auto'}`
            item.closest('.menu-mobile-improved__nav').style.overflowY = `${newValue == "open" ? 'hidden' : 'scroll'}`

            document.querySelectorAll('.menu-mobile-improved').forEach((mobileMenuImproved) => {mobileMenuImproved.setAttribute('data-sub-items-status', `${newValue}`)})
            mobileMenuFooter.setAttribute('data-transparent', true);

            item.classList.add(`${'menu-mobile-improved__nav-item--PLACEHOLDER'.replace('PLACEHOLDER', newValue)}`);                
            setTimeout(function () {
                item.style.pointerEvents = "";
                mobileMenuFooter.setAttribute('data-transparent', false)
                let scrollContainer = item.querySelector('.menu-mobile-improved__nav-item-link-content');
                if (scrollContainer && scrollContainer.scrollTop !== 0) {
                    scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
                }                        
            }, 250);
        });
    }
}

const updateMenuPosition = function(type) {
    let fixedHeaderContentHeight = window.innerWidth > 899 ? 122 : 56;
    let tempUtilityBar = window.innerWidth > 899 ? 31 : 41;

    if(type == 'utility-bar-close'){
        tempUtilityBar = 0;
    }

    if(document.querySelector('.toggle-header__utility-bar[data-current="b2b"]') && window.innerWidth < 900){
        tempUtilityBar = 0;
    }

    headerContentHeight = window.scrollY > fixedHeaderContentHeight ? fixedHeaderContentHeight : fixedHeaderContentHeight - window.scrollY;
    let topPosition = window.scrollY > scrollThreshold ? headerContentHeight - 1 : headerContentHeight + tempUtilityBar;


    mobileDropdown.style.top = `${topPosition}px`;

    /* start of test code remove later */
    mobileDropdownLegacy.style.top = `${topPosition}px`;
    /* end of test code remove later */

    updateMobileNavSliderContainerHeight();
};

const updateMobileNavSliderContainerHeight = function(){
    let utilityBarHeight = document.querySelector('.toggle-header__utility-bar') && window.scrollY <= scrollThreshold ? document.querySelector('.toggle-header__utility-bar').offsetHeight : -1;
    
    if(document.querySelector('.toggle-header__utility-bar[data-current="b2b"]') && window.innerWidth < 900){
        utilityBarHeight = -1;
    }
    
    let mobileContentHeight = `${window.innerHeight - utilityBarHeight - 56}px`;

    // console.log('mobileContentHeight', mobileContentHeight)

    document.querySelectorAll('.menu-mobile-improved__nav-item-link-content').forEach((mobileContent) => {
        mobileContent.style.height = mobileContentHeight;
        if(mobileContent.parentElement.querySelector('.menu-mobile-improved__loading-stand-in')){
            mobileContent.parentElement.querySelector('.menu-mobile-improved__loading-stand-in').style.height = mobileContentHeight;
        }
    })
}

const updateSearchBarPlaceholder = function(){    
    let truncatedText = window.Branch.functions.truncateText(searchPlaceholderText, window.innerWidth - 120, "16px Quicksand");
    if(searchContainers){
        searchContainers.forEach((searchContainer) => {
            searchContainer.querySelector('input[type="search"]').setAttribute('placeholder', truncatedText);
        })
    }
}

/* Update styling on load and on window-resize */
const updateStyling = function(){
    updateSlideDownStyling();
    updateMenuPosition();
    updateDropDownTransformValue();
    hideExcessItems();
    updateSubMenuItemHeights();
    updateBundleStepsHeaderHeights();
    updateMobileNavSliderContainerHeight();
    updateSearchBarPlaceholder();
} 

const initAllDropDowns = function(){
    allMenuItems.forEach((menuItem) => {
        if(touchDevice != true){
            if(menuItem.getAttribute('data-skip-dropdown') == 'false'){
                menuItem.addEventListener('mouseenter', toggleDropDownVisibility);
                menuItem.addEventListener('mouseleave', toggleDropDownVisibility);
            }
        } else {
            if(menuItem.getAttribute('data-skip-dropdown') == 'false'){
                menuItem.querySelector('.toggle-header-menu-bar-container__item-link').addEventListener('click', toggleDropDownVisibility);
            } else {
                let menuItemButton = menuItem.querySelector('.toggle-header-menu-bar-container__item-link')
                let innerText = menuItemButton.querySelector('span').innerHTML;
                let href = menuItemButton.getAttribute('data-href');
                menuItemButton.innerHTML = `<a href="${href}"><span>${innerText}</span></a><div class="toggle-header-menu-bar-container__item-link-underline"></div>`
            }
        }
    });
    createStandInNavItems(`.toggle-header__main-nav-stand-in-inner-container[data-type="DATATYPE"]`, 'main-nav');

    setTimeout(function(){
        headerOuter.setAttribute('data-initialized', true)
    }, 500); 
}

const toggleHeader = function(e){
    console.debug('toggle!')
    let toggleContainer = window.Branch.functions.getElementWithClass(e, 'toggle-header-title-bar-container__toggle')
    let toggleElement = window.Branch.functions.getElementWithClass(e, 'toggle-header-title-bar-container__toggle-dtc-element')

    if(toggleElement && toggleContainer){
        let newAttribute = header.getAttribute('data-current') == 'dtc' ? 'b2b' : 'dtc';
        headerOuter.setAttribute('data-transitioning', true);
        toggleContainer.setAttribute('aria-labelledby', `toggle-${newAttribute}-label`);

        header.setAttribute('data-current', `${newAttribute}`);
        if(mobileDropdown){mobileDropdown.setAttribute('data-current', `${newAttribute}`)}
        if(document.querySelector('.toggle-header__utility-bar.mobile')){document.querySelector('.toggle-header__utility-bar.mobile').setAttribute('data-current', `${newAttribute}`)}
        sessionStorage.setItem('toogleHeaderState', `${newAttribute}`);
        allFeaturedImageSections.forEach((featuredImageSection) => {
            featuredImageSection.setAttribute('data-header-state-current', `${newAttribute}`);
        })
        
        header.querySelectorAll(`.toggle-header-menu-bar-container[data-type="${newAttribute}"]`).forEach((currentMenuBar) => {
            currentMenuBar.setAttribute('aria-hidden', false)
        })
        
        header.querySelectorAll(`.toggle-header-menu-bar-container:not([data-type="${newAttribute}"])`).forEach((hiddenMenuBar) => {
            hiddenMenuBar.setAttribute('aria-hidden', true)
        });

        updateDropDownTransformValue();
        updateMenuPosition();

        setTimeout(function(){
            headerOuter.setAttribute('data-transitioning', false);
            updateSubMenuItemHeights();
            closeAllSearchContainers();
            closeAllActiveMenuItems();
        }, 500)
    }
}

const closeAllSearchContainers = function(){
    if(headerOuter.getAttribute('data-main-search-bar-visible') == 'true' || headerOuter.getAttribute('data-slide-down-search-bar-visible') == 'true') {
        searchContainers.forEach((searchContainer) => {
            searchContainer.setAttribute('data-active', false);
        })
          headerOuter.setAttribute('data-transitioning', true);
          if(headerOuter.getAttribute('data-dropdown-open') == 'false'){
            menuBar.style.overflow = 'hidden';
          }
          setTimeout(function(){
              headerOuter.setAttribute('data-transitioning', false);
              headerOuter.setAttribute('data-main-search-bar-visible', false);
              headerOuter.setAttribute('data-slide-down-search-bar-visible', false);
              setTimeout(function(){
                  menuBar.style.overflow = 'visible';
                  slideDownMenuBarContainer.style.overflow = 'visible';
              }, 250)
          }, 250)
    }
}

const initSearchButton = function(){
    searchContainers = headerOuter.querySelectorAll('.toggle-header-title-bar-container__search-container')
    slideDownMenuBarContainer = headerOuter.querySelector('.toggle-header__slide-down-menu-bar-container')
    
    searchContainers.forEach((searchContainer) => {
        const searchButton = searchContainer.querySelector('button[type="button"]:not(.toggle-header__close-search-bar)');
        const searchInput = searchContainer.querySelector('input');

        searchButton.addEventListener('click', function(event) {
          if (searchContainer.getAttribute('data-active') !== 'true') {
            setTimeout(function(){
                let searchButtonPosition = searchButton.closest('.toggle-header__slide-down-container') ? 'slide-down' : 'main';
                let dropdownOpen = false;

                event.preventDefault(); 
                headerOuter.setAttribute('data-transitioning', true);
                if(searchButtonPosition == 'main'){
                    headerOuter.setAttribute('data-main-search-bar-visible', true);
                    if(headerOuter.getAttribute('data-dropdown-open') == 'false'){
                        menuBar.style.overflow = 'hidden';
                    }
                } else {
                    headerOuter.setAttribute('data-slide-down-search-bar-visible', true);
                    if(headerOuter.getAttribute('data-dropdown-open') == 'false'){
                        slideDownMenuBarContainer.style.overflow = 'hidden';
                    }
                }
                setTimeout(function(){
                    searchContainer.setAttribute('data-active', true); 
                    searchInput.focus();
                    headerOuter.setAttribute('data-transitioning', false);
                    setTimeout(function(){
                        menuBar.style.overflow = 'visible';
                    }, 250)
                }, 240)
            }, 10);
          }
        });

    })

    document.addEventListener('click', function(event) {
        let clickOnSearchButton = false;
        let clickOutside = true;
        let clickOnCloseButton = false;

        searchContainers.forEach((searchContainer) => {
            const searchButton = searchContainer.querySelector('button[type="button"]:not(.toggle-header__close-search-bar)');
            const closeButton = searchContainer.querySelector('button[type="button"].toggle-header__close-search-bar');
    
            if(searchContainer.contains(event.target)){
                clickOutside = false;
            }

            if(closeButton.contains(event.target)){
                clickOnCloseButton = true;
            }

            if(searchButton.contains(event.target)){
                clickOnSearchButton = true;
            }
        })

        if(clickOnSearchButton == false){
            if (clickOutside == true || clickOnCloseButton == true) {
                closeAllSearchContainers();
            } 
        } else {
            if(headerOuter.getAttribute('data-main-search-bar-visible') == 'true' || headerOuter.getAttribute('data-slide-down-search-bar-visible') == 'true'){
                closeAllSearchContainers();
            }
        }
      });
    updateSearchBarPlaceholder();
}

const initToggleElement = function(){
    let primaryToggleElement = document.querySelector('.toggle-header-title-bar-container__toggle-container')
    let mobileToggleContainer = document.querySelector(".menu-mobile-improved__nav-toggle-container");
    if(primaryToggleElement && mobileToggleContainer){
        const clonedToggle = primaryToggleElement.cloneNode(true);
        mobileToggleContainer.appendChild(clonedToggle);
    }

    let toggleButtonElements = document.querySelectorAll('.toggle-header-title-bar-container__toggle-dtc-element');
    toggleButtonElements.forEach((toggleButtonElement) => {
        toggleButtonElement.addEventListener('click', toggleHeader);
    });
    allFeaturedImageSections.forEach((featuredImageSection) => {
        featuredImageSection.setAttribute('data-header-state-current', `dtc`);
    });
}

const handleMouseMove = function(event, first){
    mouseX = event.clientX;
    mouseY = event.clientY;
    if(first == true){
        triggerMouseEnterOnHoveredItem();
    }
}

const toggleHeaderDebounce = function(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

const initProductCarousels = function(parent){
    let productCarousels = parent.querySelectorAll('.toggle-header-products-list__inner-container');

    if(productCarousels.length > 0 && productCarousels[0]){
        parent.setAttribute('data-carousels-initialized', true);
    }

    productCarousels.forEach((productCarousel) => {
        let productCarouselId = productCarousel.getAttribute('data-id');
        let params = {
            spaceBetween: 24,
            slidesPerView: 1.66666,
            freeMode: false,
            autoplay: false,
            breakpoints: {
                600: {
                    slidesPerView: 2.6666,
                    spaceBetween: 24,
                    freeMode: false,
                    autoplay: false,
                },
                900: {
                    slidesPerView: 1.33333,
                    spaceBetween: 24,
                    freeMode: false,
                    autoplay: false,
                    navigation: {
                        nextEl: `.toggle-header-products-list__inner-container[data-id="${productCarouselId}"] .toggle-header-products-list__nav-right`,
                        prevEl: `.toggle-header-products-list__inner-container[data-id="${productCarouselId}"] .toggle-header-products-list__nav-left`,
                    },
                },
                1024: {
                    slidesPerView: 2.33333,
                    spaceBetween: 24,
                    freeMode: false,
                    autoplay: false,
                    navigation: {
                        nextEl: `.toggle-header-products-list__inner-container[data-id="${productCarouselId}"] .toggle-header-products-list__nav-right`,
                        prevEl: `.toggle-header-products-list__inner-container[data-id="${productCarouselId}"] .toggle-header-products-list__nav-left`,
                    },
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    freeMode: false,
                    autoplay: false,
                    navigation: {
                        nextEl: `.toggle-header-products-list__inner-container[data-id="${productCarouselId}"] .toggle-header-products-list__nav-right`,
                        prevEl: `.toggle-header-products-list__inner-container[data-id="${productCarouselId}"] .toggle-header-products-list__nav-left`,
                    },
                }
            },
            on: {
                touchStart(swiper, event) {
                    swiper.startX = event.touches ? event.touches[0].clientX : event.clientX;
                    swiper.startY = event.touches ? event.touches[0].clientY : event.clientY;
                    swiper.isClick = true; 
                },
                touchMove(swiper, event) {
                    const currentX = event.touches ? event.touches[0].clientX : event.clientX;
                    const currentY = event.touches ? event.touches[0].clientY : event.clientY;
                    const diffX = Math.abs(currentX - swiper.startX);
                    const diffY = Math.abs(currentY - swiper.startY);
                
                    if (diffY < diffX) {
                        swiper.isClick = false;
                    }
                },
                touchEnd(swiper, event) {
                  if (swiper.isClick) {
                    const targetElement = event.target.closest('.product-tile__main-link');
                    if (!targetElement) return;
                    let isSwipeUpDown = swipedTile && swipedTile.dataset.isSwipeUpDown === "true" ? true : false
                    if (targetElement.tagName === 'A' && isSwipeUpDown == false) {
                        window.location.href = targetElement.href;
                    } 
                  }
                  if(swipedTile){
                    swipedTile = undefined;
                  }
                }
            }
        };

        var toggleHeaderSwiper = new Swiper(`.toggle-header-products-list__inner-container[data-id="${productCarouselId}"] .toggle-header-products-list__carousel`, params);
    })
}

const initLinkHoverListeners = function(){
    allSubMenuItems = headerOuter.querySelectorAll('.toggle-header-menu-bar-container__submenu-item');
    allSubSubMenuItems = headerOuter.querySelectorAll('.toggle-header-menu-bar-container__sub-submenu-item');

    allSubMenuItems.forEach((subMenuItem) => {
        subMenuItem.addEventListener('mouseenter', () => {
            let parentDropDown = subMenuItem.closest('.toggle-header-menu-dropdown');
            parentDropDown.setAttribute('data-hovered-sub-link', `${subMenuItem.getAttribute('data-handle')}`);
            
            /* Single click don't follow href, double click follow href */
            if(touchDevice){
                subMenuItem.querySelector('a').addEventListener('click', (event) => {
                    if (clickTimeout) {
                        clearTimeout(clickTimeout); 
                        clickTimeout = null; 
                      } else {
                        event.preventDefault();   
                        clickTimeout = setTimeout(() => {
                          clickTimeout = null; 
                        }, 300); 
                      }
                });   
            }

            if(subMenuItem.getAttribute('data-has-dropdown') == 'false'){
                parentDropDown.setAttribute('data-hovered-link-has-dropdown', false);
            } else {
                parentDropDown.setAttribute('data-hovered-link-has-dropdown', true);
            }
        })
    })
}

const checkBusinessParam = function() {
    const urlParams = new URLSearchParams(window.location.search);
  
    if (urlParams.get('business') === 'true' && header.getAttribute('data-current') == 'dtc') {
        const ssClickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true
        });

        toggleButtonElement.dispatchEvent(ssClickEvent);
    }
  }
  

const initRichTextLinks = function(){
    let allRichTextLinks = headerOuter.querySelectorAll('.toggle-header-menu-dropdown__rich-text a');
    allRichTextLinks.forEach((link) => {
        let href = link.getAttribute('href');
        if(href.includes('business=true') && href.includes('pages') == false ){
            link.addEventListener('click', function(event) {
                event.preventDefault();
                const url = new URL(window.location);

                if (!url.searchParams.has('business')) {
                  url.searchParams.append('business', 'true');
                }

                window.history.pushState({}, '', url);
                checkBusinessParam();
              });
        }
    })
}

const initTopLevelAnchorTags = function(){
    let allTopLevelButtons = headerOuter.querySelectorAll('button.toggle-header-menu-bar-container__item-link:not([data-href="#"])');
    allTopLevelButtons.forEach((allTopLevelButton) => {
        let innerText = allTopLevelButton.querySelector('span').innerHTML;
        let href = allTopLevelButton.getAttribute('data-href');
        allTopLevelButton.innerHTML = `<a href="${href}"><span>${innerText}</span></a><div class="toggle-header-menu-bar-container__item-link-underline"></div>`
    })
}

const repositionNavItems = function(intoSlideDown, result){
    let innerUlDTC;
    let newContainerDTC;
    let oldContainerDTC; 

    let innerUlB2B;
    let newContainerB2B;
    let oldContainerB2B; 
    
    if(intoSlideDown){
        innerUlDTC = header.querySelector(`.toggle-header-menu-bar-container[data-type="dtc"] > ul`);
        newContainerDTC = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="dtc"]');  
        oldContainerDTC = header.querySelector(`.toggle-header-menu-bar-container[data-type="dtc"]`);

        innerUlB2B = header.querySelector(`.toggle-header-menu-bar-container[data-type="b2b"] > ul`);
        newContainerB2B = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="b2b"]');  
        oldContainerB2B = header.querySelector(`.toggle-header-menu-bar-container[data-type="b2b"]`);
    } else {
        innerUlDTC = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="dtc"] > ul');
        newContainerDTC = header.querySelector(`.toggle-header-menu-bar-container[data-type="dtc"]`);
        oldContainerDTC = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="dtc"]')

        innerUlB2B = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="b2b"] > ul');
        newContainerB2B = header.querySelector(`.toggle-header-menu-bar-container[data-type="b2b"]`);
        oldContainerB2B = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="b2b"]')
    }

    if(innerUlDTC && newContainerDTC && oldContainerDTC) {
        newContainerDTC.appendChild(innerUlDTC);
        oldContainerDTC.innerHTML = '';
    }

    if(innerUlB2B && newContainerB2B && oldContainerB2B) {
        newContainerB2B.appendChild(innerUlB2B);
        oldContainerB2B.innerHTML = '';
    }

    slideDown.setAttribute('data-active', `${result}`);
    menuBar.setAttribute('data-stand-in-open', `${result}`);
    hideExcessItems();
}

const displayHideToast = function() {
    let toastElements = headerOuter.querySelectorAll('.toggle-header-title-bar-container__toggle-toast-container');
    let headerToggleToastShown = sessionStorage.getItem('headerToggleToastShown') && sessionStorage.getItem('headerToggleToastShown') == 'true';

    if (headerToggleToastShown) {
        toastElements.forEach((toastElement) => {
            toastElement.style.display = 'none';
        });
    } else {
        toastElements.forEach((toastElement) => {
            let delay = parseInt(toastElement.getAttribute('data-loading-delay'))
            let duration = parseInt(toastElement.getAttribute('data-display-duration'))
            setTimeout(() => {
                toastElement.setAttribute('data-display', true)
                setTimeout(() => {
                    toastElement.setAttribute('data-display', false);
                    setTimeout(() => {
                        toastElement.style.display = 'none';
                        sessionStorage.setItem('headerToggleToastShown', 'true');
                    }, 250); 
                }, duration * 1000); 
            }, delay * 1000);
        })
    }
}

const tempReduceTransitionDuration = function(){
    titleBar.parentElement.setAttribute('data-speed-up-transition', true)
    setTimeout(function(){
        titleBar.parentElement.setAttribute('data-speed-up-transition', false)
    }, 500)
}

const preLoadCarouselImages = function(){
    window.Branch.product.preloadImages(undefined, 'click', 'toggle-header', undefined);
}

const toggleFromSessionHistory = function() {
    const urlParams = new URLSearchParams(window.location.search);

    // Check for the "business=true" query parameter
    if (urlParams.get('business') === 'true') {
        const ssClickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true
        });
        tempReduceTransitionDuration();
        toggleButtonElement.dispatchEvent(ssClickEvent);

        sessionStorage.setItem('toogleHeaderState', 'b2b');
    } else {
        let prevState = sessionStorage.getItem('toogleHeaderState');
        if (prevState && prevState === 'b2b') {
            const ssClickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true
            });
            tempReduceTransitionDuration();
            toggleButtonElement.dispatchEvent(ssClickEvent);
        } else if (!prevState || (prevState && prevState !== 'b2b')) {
            checkBusinessParam();
        }
    }
};


/* Product page overlapping logic */
const productPageStickyAtcCheck = function(){
    let staticATC = document.querySelector(".main-product__atc-container");
    let bulkDiscountsOpen = document.querySelector('.bulk-discounts-dropdown--open');

    if (staticATC && document.querySelector('body').classList.contains('templateProduct') && !bulkDiscountsOpen) {
        let atcOffScreen = window.Branch.functions.isElementVisibleOrBelow('.main-product__atc-container #atc-cta');
        if(atcOffScreen){
            sectionOuter.setAttribute('data-atc-visible', true);
        } else {
            sectionOuter.setAttribute('data-atc-visible', false);
        }
    }
}

window.Branch.nav.handleNavLinkClick = function(type){
    let navLinks = document.querySelectorAll('.menu-mobile-improved__nav-link');
    let menu = document.querySelector('.menu-mobile-improved');



    menu.classList.remove(`${menuMobileImprovedClass.replace('STATUS', 'closed')}`);
    menu.classList.remove(`${menuMobileImprovedClass.replace('STATUS', 'open')}`);
    
    /* start of test code remove later */
    let legacyMenu = document.querySelector('.menu-mobile-improved-legacy');
    legacyMenu.classList.remove(`${menuMobileImprovedClassLegacy.replace('STATUS', 'closed')}`);
    legacyMenu.classList.remove(`${menuMobileImprovedClassLegacy.replace('STATUS', 'open')}`);
    /* end of test code remove later */
    
    let newStatus = menu.getAttribute('data-status') == 'closed' ? 'open' : 'closed'; 

    if(type == 'click outside') {
        newStatus = 'closed'
    };

    let html = document.querySelector('#page').closest('html');
    if(newStatus == 'open'){
        html.style.overflow = `hidden` 
        html.setAttribute('data-menu-open', true);
    } else {
        html.style.overflow = `` 
        html.removeAttribute('data-menu-open');
    }

    if(newStatus == 'open'){
        document.querySelectorAll('#fc_frame').forEach((fcFrame) => {fcFrame.style.height = '0'; fcFrame.style.minHeight = '0'; fcFrame.style.overflow = 'hidden';});
    } else {
        document.querySelectorAll('#fc_frame').forEach((fcFrame) => {fcFrame.style.removeProperty('height');fcFrame.style.removeProperty('minHeight');fcFrame.style.removeProperty('overflow');});
    }

    navLinks.forEach((navLink) => {
        navLink.style.pointerEvents = "none";

        let navLinkIcon = navLink.querySelector('.menu-mobile-improved__nav-icon');

        navLinkIcon.classList.remove(`${navLinkIconStatusClass.replace('STATUS', 'closed')}`);
        navLinkIcon.classList.remove(`${navLinkIconStatusClass.replace('STATUS', 'open')}`);
        navLink.setAttribute('data-status', `${newStatus}`);
        navLinkIcon.classList.add(`${navLinkIconStatusClass.replace('STATUS', newStatus)}`);
    
        setTimeout(function () {
            navLink.style.pointerEvents = "";
        }, 250);
    
    });

    menu.setAttribute('data-status', `${newStatus}`);
    menu.classList.add(`${menuMobileImprovedClass.replace('STATUS', newStatus)}`)
    
    /* start of test code remove later */
    legacyMenu.setAttribute('data-status', `${newStatus}`);
    legacyMenu.classList.add(`${menuMobileImprovedClassLegacy.replace('STATUS', newStatus)}`)
    /* end of test code remove later */

}

const initMobileMenu = function(){
    if(header){
        header.addEventListener('click', function(event) {
            if (event.target.closest('.menu-mobile-improved__nav-link')) {window.Branch.nav.handleNavLinkClick()}
        });
        header.addEventListener('wheel', function(event){if(mobileDropdown && mobileDropdown.getAttribute('data-status') == 'open'){event.preventDefault()}}, {passive: false});
        header.addEventListener('touchmove', function(event){if(mobileDropdown && mobileDropdown.getAttribute('data-status') == 'open'){event.preventDefault()}}, {passive: false});
    }
    if(slideDown){
        slideDown.addEventListener('click', function(event) {
            if (event.target.closest('.menu-mobile-improved__nav-link')) {window.Branch.nav.handleNavLinkClick()}
        });
        slideDown.addEventListener('wheel', function(event){if(mobileDropdown && mobileDropdown.getAttribute('data-status') == 'open'){event.preventDefault()}}, {passive: false});
        slideDown.addEventListener('touchmove', function(event){if(mobileDropdown && mobileDropdown.getAttribute('data-status') == 'open'){event.preventDefault()}}, {passive: false});
    }
    if(mobileDropdown){
        mobileDropdown.addEventListener('click', function(event) {
            if (event.target.closest('.menu-mobile-improved__close-icon-container')) {
                handleMobileNavItemClick(event, 'click_outside', 0)
            }
        })
    }

    headerOuter.setAttribute('data-mobile-nav-btn-activated', true)

    menuMobileInnerContainer.setAttribute('data-scrolled-to-top', menuMobileInnerContainer.scrollTop === 0)
    menuMobileInnerContainer.addEventListener('scroll', function(){
        menuMobileInnerContainer.setAttribute('data-scrolled-to-top', menuMobileInnerContainer.scrollTop === 0)
    });

    function preventUpwardScroll(event, type) {
        if(!event.target.closest('.menu-mobile-improved__nav-item-link-content') && !event.target.closest('.menu-mobile-improved__loading-stand-in')){
            const scrolledToTop = menuMobileInnerContainer.getAttribute("data-scrolled-to-top") === "true";
            if(type == 'wheel'){
                if (scrolledToTop && event.deltaY < 0) {
                    event.preventDefault();
                }
            } else {
                if (scrolledToTop) {
                    const touch = event.touches[0];
                    if (touch.clientY > menuMobileInnerContainer.lastTouchY) {
                        event.preventDefault(); 
                    }
                }
            }
        }
    }

    menuMobileInnerContainer.addEventListener("wheel", (event) => preventUpwardScroll(event, 'wheel'), { passive: false });
    menuMobileInnerContainer.addEventListener("touchmove", (event) => preventUpwardScroll(event, 'touchmove'), { passive: false });
}

const initNavItemSlider = function(navItemIndex){
      var swiper = new Swiper(`.menu-mobile-improved__sub-nav-items-container[data-item-index="${navItemIndex}"]`, {
        slidesPerView: 2.5,
        spaceBetween: 20,
        freeMode: true
      });
}

const initMobileNavItemState = function(){
    let navItemsWithDropdown = document.querySelectorAll(`.menu-mobile-improved__nav-item--has-dropdown`);
    if(navItemsWithDropdown.length > 0){
        navItemsWithDropdown.forEach((navItemWithDropdown) => {
            navItemWithDropdown.querySelector('.menu-mobile-improved__nav-item-link').addEventListener('click', function(e){
                    handleMobileNavItemClick(e, 'click', parseInt(navItemWithDropdown.getAttribute('data-item-index')))
                }
            )
        initNavItemSlider(navItemWithDropdown.getAttribute('data-item-index'));
        })
    }
}

const copySection = function(type, linkContent, originalElement, data, handle, wrapperClassName){
    const clonedElement = originalElement.cloneNode(true);

    if(type == 'rich-text'){
        clonedElement.querySelectorAll("style").forEach(style => style.remove());
        clonedElement.querySelectorAll(".toggle-header-menu-dropdown__rich-text:not([data-handle='default'])").forEach(el => el.remove());    
    }

    if(type == 'bundles'){
        clonedElement.querySelectorAll(".toggle-header-menu-dropdown__bundle-step-title").forEach(title => title.style.removeProperty("height"));
    }
    
    const wrapper = document.createElement('div');
    wrapper.className = wrapperClassName;

    const seperator = document.createElement('div');
    seperator.className = 'menu-mobile-improved__nav-item-seperator';

    if(type == 'bundles' && data && data.hide_product_list == 'true'){
        const title = document.createElement('div');
        title.className = 'menu-mobile-improved__nav-item-product-link-header';
        title.innerHTML = `${linkContent.closest('.menu-mobile-improved__nav-item').querySelector('.menu-mobile-improved__nav-item-link ').innerHTML}`
        wrapper.appendChild(title);
    }

    wrapper.appendChild(clonedElement);
    linkContent.appendChild(wrapper);
    linkContent.appendChild(seperator);
}

const copyProductList = function(linkContent, handle, productList){
    let lastElement = productList.querySelector(`.toggle-header-products-list__inner-container[data-link-handle="${handle}"]`);
    
    if(!lastElement || lastElement && lastElement.querySelectorAll('.product-tile').length == 0){
        lastElement = productList.querySelector(`.toggle-header-products-list__inner-container:not([data-link-handle="${handle}"])`);
    }

    if (lastElement) {
        const clonedElement = lastElement.cloneNode(true);
        const wrapper = document.createElement('div');
        wrapper.className = 'menu-mobile-improved__nav-item-product-link-container';

        const seperator = document.createElement('div');
        seperator.className = 'menu-mobile-improved__nav-item-seperator';

        const title = document.createElement('div');
        title.className = 'menu-mobile-improved__nav-item-product-link-header';
        title.innerHTML = `${linkContent.closest('.menu-mobile-improved__nav-item').querySelector('.menu-mobile-improved__nav-item-link ').innerHTML}`

        const getRandomId = () => Math.floor(10000 + Math.random() * 90000);

        clonedElement.setAttribute('data-id', getRandomId());
        clonedElement.querySelectorAll('.product-tile').forEach(tile => {
            tile.setAttribute('data-id', getRandomId());
        });
        wrapper.appendChild(title);
        wrapper.appendChild(clonedElement);
        linkContent.appendChild(wrapper);
        linkContent.appendChild(seperator);
    }
}

const copyCta = function(origin, linkContent, cta, type, footerContent){
    const separators = linkContent && origin == 'slide-out' ? linkContent.querySelectorAll('.menu-mobile-improved__nav-item-seperator') : [];
    if (separators.length > 0) {
        separators[separators.length - 1].remove();
    }

    const clonedElement = cta.cloneNode(true);
    clonedElement.querySelector(`.toggle-header-title-bar-container__cta:not([data-type="${type}"])`).remove();

    let chatWithSalesStatus = cta.closest('.toggle-header-title-bar-container__utils-inner') ? cta.closest('.toggle-header-title-bar-container__utils-inner').getAttribute('data-chat-with-sales-display') : undefined;

    const wrapper = document.createElement('div');
    wrapper.className = 'menu-mobile-improved__nav-item-cta-container';
    
    if(chatWithSalesStatus){
        wrapper.setAttribute('data-chat-with-sales-display', chatWithSalesStatus)
    }
    
    

    if (cta.previousElementSibling?.classList.contains('toggle-header-title-bar-container__chat-with-sales-button')){
        wrapper.appendChild(cta.previousElementSibling.cloneNode(true));
    }

    

    wrapper.appendChild(clonedElement);
    if(origin == 'main'){
        wrapper.setAttribute('data-type', type)
    }

    if(footerContent && origin == 'slide-out'  ){
        let clonedFooterContent = footerContent.cloneNode(true)
        clonedFooterContent.querySelector(`.menu-mobile-improved__footer-ctas-container`).remove();
        clonedFooterContent.querySelector(`.menu-mobile-improved__additional-links-container`).remove();
        wrapper.appendChild(clonedFooterContent);
    }

    linkContent.appendChild(wrapper);
    if(origin == 'main' && type == "b2b"){
        const seperator = document.createElement('div');
        seperator.className = 'menu-mobile-improved__nav-item-seperator';
        linkContent.appendChild(seperator);
    }
}

const copyNavSubItems = function(linkContent, navSubItems, data){
    const clonedElement = navSubItems.cloneNode(true);
    if(data && data.sub_menu_items_to_exclude_mobile.length > 0){
        data.sub_menu_items_to_exclude_mobile[0].forEach((sub_menu_item_handle) => {
            clonedElement.querySelectorAll('.toggle-header-menu-bar-container__submenu-item').forEach((submenuItem) => {
                if(submenuItem.getAttribute('data-handle') == sub_menu_item_handle){
                    submenuItem.remove();
                }
            })
        })
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'menu-mobile-improved__nav-item-sub-items-container';

    const seperator = document.createElement('div');
    seperator.className = 'menu-mobile-improved__nav-item-seperator';

    const submenuItems = Array.from(clonedElement.querySelectorAll('[data-sub-menu-items-layout="sub-menu-items-and-sub-sub-menu-items"] .toggle-header-menu-bar-container__submenu-item'));


    if (submenuItems.length > 0) {
        const newContainer = document.createDocumentFragment();

        for (let i = 0; i < submenuItems.length; i += 2) {
            const container = document.createElement('div');
            container.className = 'toggle-header-menu-bar-container__submenu-item-container';
            container.appendChild(submenuItems[i]);
            if (submenuItems[i + 1]) {
                container.appendChild(submenuItems[i + 1]);
            }
            newContainer.appendChild(container);

            if (i + 2 < submenuItems.length) {
                newContainer.appendChild(seperator.cloneNode(true));
            }
        }

        clonedElement.querySelector('.toggle-header-menu-bar-container__submenu').innerHTML = '';
        clonedElement.querySelector('.toggle-header-menu-bar-container__submenu').appendChild(newContainer);
    }

    wrapper.appendChild(clonedElement);
    linkContent.appendChild(wrapper);
    linkContent.appendChild(seperator);
}

const initUtilityBarLinks = function(){
    mobileMenuFooter.addEventListener('click', function(event){
        if(event.target.closest('.utility-bar__link-anchor')){
            let anchor = event.target.closest('.utility-bar__link-anchor');
            event.preventDefault();
            let newStatus = anchor.closest('.menu-mobile-improved__utility-link').getAttribute('data-status') == 'open' ? 'closed' : 'open';
            document.querySelectorAll('.menu-mobile-improved__utility-link').forEach((utilityLink) => {utilityLink.setAttribute('data-status', 'closed')});
            anchor.closest('.menu-mobile-improved__utility-link').setAttribute('data-status', `${newStatus}`)
        }
    })
}

const copyUtilityBarLinks = function(){
    let utilityLinksContainer = document.querySelector('.menu-mobile-improved__additional-links-container');
    let originalUtilityBarLinks = document.querySelectorAll('.utility-bar__links .upper-menu-item');
    const utilityLinks = document.createElement('ul');
    utilityLinks.className = 'menu-mobile-improved__utility-links';
    originalUtilityBarLinks.forEach((originalUtilityBarLink, index) => {
        const utilityLinkTopLevel = document.createElement('li');
        utilityLinkTopLevel.className = 'menu-mobile-improved__utility-link';
        utilityLinkTopLevel.setAttribute('data-status', 'closed');

        let clonedInnerLink = originalUtilityBarLink.querySelector('.utility-bar__link').cloneNode(true);
        clonedInnerLink.setAttribute('data-index', index);
        clonedInnerLink.className = 'utility-bar__link-anchor'
        utilityLinkTopLevel.appendChild(clonedInnerLink)

        const clonedSubLinkItems = document.createElement('ul');
        clonedSubLinkItems.innerHTML = originalUtilityBarLink.querySelector('.upper-menu-item-children').cloneNode(true).innerHTML;
        clonedSubLinkItems.className = 'menu-mobile-improved__utility-sub-links';
        clonedSubLinkItems.style.height = `${clonedSubLinkItems.children.length * 25.2}px`;

        Array.from(clonedSubLinkItems.children).forEach(child => {
            const li = document.createElement('li');
            li.appendChild(child.querySelector('a').cloneNode(true));
            li.className = 'menu-mobile-improved__utility-sub-link'
            child.replaceWith(li);
        });

        utilityLinkTopLevel.appendChild(clonedSubLinkItems)
        utilityLinks.appendChild(utilityLinkTopLevel);
    });
    
    utilityLinksContainer.appendChild(utilityLinks);

    if(document.querySelector('.utility-bar__link#friendbuyoverlay')){
        utilityLinksContainer.appendChild(document.querySelector('.utility-bar__link#friendbuyoverlay').cloneNode(true))
    }

    initUtilityBarLinks();
}

const initProductTileSwipeDownClickPrevent = function(){
    mobileDropdown.addEventListener("touchstart", (e) => {
        if(e.target.closest(".product-tile__main-link")){
            swipedTile = e.target.closest(".product-tile__main-link");
            swipedTile.dataset.startY = e.touches[0].clientY;
            swipedTile.dataset.isSwipeUpDown = "false";
        }        
    });
    
    mobileDropdown.addEventListener("touchmove", (e) => {
        if(e.target.closest(".product-tile__main-link") && swipedTile){
            let diff = e.touches[0].clientY - swipedTile.dataset.startY;
            if (Math.abs(diff) > 20) {
                swipedTile.dataset.isSwipeUpDown = "true";
            }
        }
    });
}

const copyDesktopContentToMobile = function(){
    let allMobileNavItems = document.querySelectorAll('.menu-mobile-improved__nav-item.menu-mobile-improved__nav-item--has-dropdown');
    let toggleCtas = document.querySelectorAll('.toggle-header-title-bar-container__ctas');
    let footerContent = document.querySelector('.menu-mobile-improved__footer');
    let closeButtonHTML = `<div class="menu-mobile-improved__close-icon-container"><button aria-label="Close opened sub menu" class="menu-mobile-improved__close-icon-button"><svg aria-hidden="false" tabindex="-1" role="presentation" class="transition icon icon-arrow-left left-arrow" viewBox="0 0 32 32"><path fill="#98a19c" d="M12.6354 16L26 3.555L22.1823 0L5 16L22.1823 32L26 28.445L12.6354 16Z"></path></svg><span>Back</span></button></div>`;

    ['dtc', 'b2b'].forEach((type, index) => {
        let cta = toggleCtas[index];
        let linkContent = document.querySelector('.menu-mobile-improved__footer-ctas-container');
        copyCta('main', linkContent, cta, type, footerContent);
    });


    copyUtilityBarLinks();


    allMobileNavItems.forEach((mobileNavItem) => {
        let linkContent = mobileNavItem.querySelector('.menu-mobile-improved__nav-item-link-content');
        let type = mobileNavItem.getAttribute('data-item-type');
        let name = mobileNavItem.getAttribute('data-menu-name');
        let data = toggleHeaderData[`${name}___${type}`]
        let cta = toggleCtas[0];
        let equivalentDesktopContent = document.querySelector(`.toggle-header-menu-bar-container[data-type="${type}"] .toggle-header-menu-bar-container__item[data-parent="${name}"] .toggle-header-menu-dropdown, .toggle-header__slide-down-nav-container[data-type="${type}"] .toggle-header-menu-bar-container__item[data-parent="${name}"] .toggle-header-menu-dropdown`)
        if(equivalentDesktopContent){

            linkContent.insertAdjacentHTML('afterbegin', closeButtonHTML);

            let productList = equivalentDesktopContent.querySelector('.toggle-header-menu-dropdown__products-list-outer-container');
            if(productList){
                if(data && data.hide_product_list == 'false'){
                    copyProductList(linkContent, 'default', productList);
                    if(name == 'sale'){
                    }
                }
                if(data && data.additional_product_lists_for_mobile.length > 0){
                    data.additional_product_lists_for_mobile[0].forEach((additional_list) => {
                        copyProductList(linkContent, `${additional_list}`, productList);
                    })
                }
            }

            let bundleSection = equivalentDesktopContent.querySelector('.toggle-header-menu-dropdown__bundle-steps-outer-container');
            if(bundleSection){
                copySection('bundles', linkContent, bundleSection, data, null, 'menu-mobile-improved__nav-item-bundles-container')
            }

            let navSubItems = equivalentDesktopContent.querySelector('.toggle-header-menu-dropdown__submenu-container');
            if(navSubItems){
                copyNavSubItems(linkContent, navSubItems, data);
            }

            let richTextSection = equivalentDesktopContent.querySelector('.toggle-header-menu-dropdown__rich-text-outer-container');
            
            if(richTextSection){
                copySection('rich-text', linkContent, richTextSection, data, null, 'menu-mobile-improved__nav-item-rich-text-container')
            }

            let logoSection = equivalentDesktopContent.querySelector('.toggle-header-menu-dropdown__logos-element-outer-container');
            if(logoSection){
                copySection('logos', linkContent, logoSection, data, null, 'menu-mobile-improved__nav-item-logos-container')
            }

            copyCta('slide-out', linkContent, cta, type, footerContent);
        }
    })
    mobileDropdown.setAttribute('data-all-content-copied', true);
    setTimeout(() => {
        updateSubMenuItemHeights();
        mobileDropdown.querySelectorAll('.menu-mobile-improved__nav-item').forEach((currentItemDropdown) => {
            if(currentItemDropdown.getAttribute('data-carousels-initialized') == 'false'){                
                initProductCarousels(currentItemDropdown);
            }
        });
        initSalesTags();
    }, 500)
}

const initSalesTags = function(){
    let allSalesTags = document.querySelectorAll('#shopify-section-header .sale');
    allSalesTags.forEach((salesTag) => {
        let salesTagText = window.Branch.functions.returnSalesTagText(salesTag);
        if(salesTagText != ""){
            salesTag.setAttribute('data-display', true);
            salesTag.innerHTML = salesTagText;
            salesTag.setAttribute('data-sale-text', salesTagText);
        } else {
            salesTag.setAttribute('data-display', false);
        }
    })
}

const initUtilityBarObserver = function(){
    let utilityBar = document.querySelector(`#header .utility-bar`);
    let mutating = false;

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === "attributes" && mutating == false) {
                mutating = true;
                updateMenuPosition('utility-bar-close')
                setTimeout(function() {
                    mutating = false;
                }, 500);
            }
        });
    });

    if(utilityBar){
        observer.observe(utilityBar, {attributes: true});
    }
}

const handleToggleHeaderScroll = function() {
    let prevSlideDownVisible = slideDownVisible == true;
    if(reusableVariablesInitialized == false) {
        initToggleHeaderReusableVariableDeclarations();
    }
    if (window.scrollY > scrollThreshold) {
        const result = window.Branch.functions.isElementPartiallyOffScreen('.toggle-header__menu-bar');

        if (result) {
            slideDown.style.transform = `translateY(0)`;
            repositionNavItems(true, result);
            slideDownVisible = true;
        } else {
            slideDown.style.transform = `translateY(-${slideDownLayout == 'nav_items_bar_and_header_bar' ? menuBar.offsetHeight + titleBar.offsetHeight : menuBar.offsetHeight}px)`;
            repositionNavItems(false, result);
            slideDownVisible = false;
        }
    } else {
        slideDown.style.transform = `translateY(-${slideDownLayout == 'nav_items_bar_and_header_bar' ? menuBar.offsetHeight + titleBar.offsetHeight : menuBar.offsetHeight}px)`;
        repositionNavItems(false, false);
        slideDownVisible = false;
    }
    if(prevSlideDownVisible != slideDownVisible){
        closeAllSearchContainers();
    }

    productPageStickyAtcCheck();
    updateMenuPosition();
}

window.addEventListener('mousemove', toggleHeaderDebounce((e) => {
    if(header){
        if(touchDevice == false){
            handleMouseMove(e, true);
        }
    }
}, 250), { once: true });

window.addEventListener("DOMContentLoaded", function() {
    initToggleHeaderReusableVariableDeclarations();
    if(header){
        updateStyling();
        initMobileMenu();

        initToggleElement();
        toggleFromSessionHistory();

        initAllDropDowns();
        initSearchButton();
        initLinkHoverListeners();
        if(!touchDevice){
            initTopLevelAnchorTags();
        }
        initMobileNavItemState();
        initRichTextLinks();
        displayHideToast();
        productPageStickyAtcCheck();
        initProductTileSwipeDownClickPrevent();
        initUtilityBarObserver();
        
    }
});

window.addEventListener('load', function() {
    let interval = setInterval(function() {
        if (header && reusableVariablesInitialized == true) {
            console.log('loaded ready to copy')
            copyDesktopContentToMobile();
            clearInterval(interval);
        }
    }, 100);
});

window.addEventListener('resize', () => {
    if(reusableVariablesInitialized == false){
        initToggleHeaderReusableVariableDeclarations()
    }
    if(header){
        if(toggleHeaderWindowWidth > 899 && window.innerWidth < 900 || toggleHeaderWindowWidth < 900 && window.innerWidth > 899){
            headerOuter.style.opacity = '0'
        }
    }
});

window.addEventListener('resize', () => {
    if(header){
        clearTimeout(toggleHeaderResizeTimeout);
        toggleHeaderResizeTimeout = setTimeout(() => {
        if(toggleHeaderWindowWidth != window.innerWidth){
            updateStyling();   
            toggleHeaderWindowWidth = window.innerWidth;
            setTimeout(() => {
                headerOuter.style.opacity = '1'
            }, 300)
        }
        }, 200); 
    }
});

window.addEventListener('scroll', toggleHeaderDebounce(() => {
    if(header){
        handleToggleHeaderScroll();
    }
}, 200));
